import React from "react";
import { useNavigate } from "react-router-dom";

import { Box } from "@mui/material";
import { NotificationsOutlined, Circle } from "@mui/icons-material";

import { useOnNotificationReadMutation } from "store/services/notificationApi";

import { humanizeDate } from "utils/dateFormats";
import { getDetailLink } from "utils/getDetailLink";
import { useAuth } from "hooks";

const NotificationMessage = (props) => {
  const {
    message,
    isInReadByField,
    _id,
    onRead,
    createdAt,
    sourceModel,
    sourceRef,
    closePopover,
    type,
    contextData,
  } = props;

  const [isRead, setIsRead] = React.useState(isInReadByField);

  const navigate = useNavigate();

  const [markAsRead, { isLoading, isFetching }] =
    useOnNotificationReadMutation();

  const { loggedInUser, isCustomer, isDriver, isContractor, isVendor, isVendorStaff } =
    useAuth();

  const isBusy = isLoading || isFetching;

  const notificationClicked = async () => {
    if (!isInReadByField) {
      try {
        setIsRead(true);
        await markAsRead(_id).unwrap();
        onRead(_id);
      } catch (e) { }
    }

    navigate(
      getDetailLink({
        sourceModel,
        sourceRef,
        type,
        isVendor: isVendor,
        vendor: loggedInUser._id,
        intendedUser: loggedInUser._id,
        isCustomer: isCustomer,
        customerId: loggedInUser?.typeRef,
        isDriver: isDriver,
        driverId: loggedInUser?.typeRef,
        isContractor: isContractor,
        isVendorStaff: isVendorStaff,
        contextData,
      })
    );
    closePopover();
  };

  React.useEffect(() => {
    setIsRead(isInReadByField);
  }, [isInReadByField]);

  return (
    <>
      <Box
        onClick={notificationClicked}
        className="flex cursor-pointer flex-row items-start  gap-3 px-3 py-2 hover:bg-slate-100 dark:hover:bg-slate-600"
      >
        <Box
          sx={{
            minWidth: "40px",
            minHeight: "40px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            padding: 0,
          }}
          className="  rounded-full bg-blue-50"
        >
          <NotificationsOutlined color="primary" fontSize="small" />
        </Box>

        <Box className="relative flex w-full  flex-col ">
          <div className="flex w-full gap-1 ">
            <p className=" text-xs text-slate-600 line-clamp-2 dark:text-slate-100 ">
              {message}
            </p>
            {!isRead ? (
              isBusy ? null : (
                <Circle
                  className=" ml-auto text-blue-500"
                  sx={{
                    fontSize: "13px",
                  }}
                />
              )
            ) : null}
          </div>
          <p className=" text-xs font-medium text-slate-400 dark:text-slate-400">
            {humanizeDate(createdAt)}
          </p>
        </Box>
      </Box>
    </>
  );
};

export default NotificationMessage;
